import {PIXI, Scrollbox} from '@colonist/pixi'
import {uiGameManager} from '../../EntryShared'
import {GameColor} from '../../GameColor'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export class UIGameTradeOffersScrollbox extends Scrollbox {
    private readonly maxHeight: number
    private isPointerOver: boolean

    constructor(container: PIXI.Container, x: number, y: number, width: number) {
        const {itemSize, margin} = uiGameManager.canvasController

        const scrollbarBgColor = GameColor.getColorHexValue(UIUtilsEjsVariables.isUserOnMobileApp ? GameColor.Color.PrimaryBlue6 : GameColor.Color.Gray1)
        const scrollbarFgColor = GameColor.getColorHexValue(GameColor.Color.White)
        const scrollbarFgAlpha = UIUtilsEjsVariables.isUserOnMobileApp ? 1 : 0.8

        super({
            boxWidth: width,
            boxHeight: 0,
            scrollbarBackground: scrollbarBgColor,
            scrollbarForeground: scrollbarFgColor,
            scrollbarForegroundAlpha: scrollbarFgAlpha,
            scrollbarSize: width / 65,
            scrollbarOffsetVertical: -margin,
            events: uiGameManager.canvasController.app.renderer.events,
        })

        this.initializeEvents()

        this.position.set(x, y)
        const maxHeightForWeb = itemSize * 5.5 + margin * 2
        this.maxHeight = this.getScrollboxHeightForMobile() ?? maxHeightForWeb

        container.addChild(this)
    }

    private initializeEvents() {
        // TODO once updated to pixi-scrollbox 2.3.0 this can be replaced with divWheel option
        uiGameManager.canvasController.app.view.addEventListener('wheel', (event) => {
            if(!this.isPointerOver) return

            event.stopPropagation()
            this.scrollTop += event.deltaY * 0.15
        }, {
            capture: true,
        })

        this.on('pointerover', () => this.isPointerOver = true)
        this.on('pointerout', () => this.isPointerOver = false)
    }

    updateHeight(newHeight?: number) {
        const height = newHeight ?? this.content.height
        this.boxHeight = Math.min(height, this.maxHeight)
    }

    destroyAndClear() {
        this.isPointerOver = false
        this.destroy({children: true})
    }

    // eslint-disable-next-line class-methods-use-this
    private getScrollboxHeightForMobile(): number | undefined {
        if(!UIUtilsEjsVariables.isUserOnMobileApp) return
        if(!UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return

        const {itemSize, margin} = uiGameManager.canvasController
        if(UIUtilsEjsVariables.isUserOnTabletApp) return itemSize * 4.5 + margin * 2

        const maxHeightForIphoneSE = 600
        const isMobileScreenSmall = window.innerHeight < maxHeightForIphoneSE
        if(isMobileScreenSmall) return itemSize * 2.5 + margin
        return itemSize * 4.5 + margin * 2
    }
}
